import React from "react";
import { Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const ProgressBar = ({ length, currentStep }) => {
    const styles = {
        circle: {
            borderRadius: '50%',
            border: "3px solid gray",
            color: "gray",
            textAlign: "center",
            width: "30px",
            height: "30px",
            font: '16px Arial, sans-serif'
        }
    }

    const ProgressBarSection = (props) => {
        const { completed } = props;

        const containerStyles = {
            height: 5,
            width: 40,
            backgroundColor: "#e0e0de",
            borderRadius: 50,
        }

        const fillerStyles = {
            height: '100%',
            width: `${completed}%`,
            backgroundColor: 'var(--base-color-dark-blue)',
            borderRadius: 'inherit',
            textAlign: 'right'
        }


        return (
            <div className="d-flex" style={containerStyles}>
                <div data-testid="progressSegment" style={fillerStyles} />
            </div>
        );
    };

    const RenderProgressBar = () => {
        let td = [];

        for (let i = 1; i <= length; i++) {
            let progress;
            let isCompleted = false;
            const lastStep = i === length;

            if (i == currentStep - 1) {
                progress = 50;
                isCompleted = true;
            }
            else if (i < currentStep) {
                progress = 100;
                isCompleted = true;
            }           
            else {
                progress = 0;
            }
            td.push(
                <Row key={i} className="d-flex align-items-center m-1">
                    {isCompleted ? <FontAwesomeIcon title={`check-${i}`} className="mr-1" icon={faCircleCheck} style={{ color: "var(--base-color-dark-blue)", height:30, width: 30 }} /> : <div className="mr-1 pt-1" style={styles.circle}>{i}</div>}
                    {!lastStep && <ProgressBarSection completed={progress} />}
                </Row>
            );
        }
        return td;
    };
    return (
        <Row className="">
            <RenderProgressBar />
        </Row>
    )
}

export default ProgressBar;